<template>
  <div :class="'form-group' + (invalidFeedback?' has-error':'')">
    <label class="control-label">{{label}}</label>
    <slot>
    </slot>
    <span v-if="invalidFeedback" class="help-block">
      <template v-if="description">
        {{description}}
        <br/>
      </template>

      {{invalidFeedback}}
    </span>
    <span v-else-if="description" class="help-block">
      {{description}}
    </span>
  </div>
</template>
<script>
  export default {
    props: [
      'label', 'invalidFeedback', 'description'
    ],
    name: 'formGroup',
    data () {
      return {}
    },
    methods: {}
  }
</script>
<style>
</style>
